/**
 *
 * @param {Object} props
 * @param {String} [props.color] - The color of the icon.
 * @param {String} [props.size] - The size of the icon.
 * @returns
 */
export const RocketLaunchIconOutline = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "25"}
      height={size ?? "24"}
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M15.7565 14.3696C15.8608 14.8128 15.916 15.275 15.916 15.75C15.916 19.0637 13.2297 21.75 9.91602 21.75V16.9503M15.7565 14.3696C19.4904 11.6411 21.916 7.22874 21.916 2.25C16.9375 2.25021 12.5255 4.67586 9.79723 8.40975M15.7565 14.3696C14.0479 15.6181 12.0654 16.514 9.91602 16.9503M9.79723 8.40975C9.35379 8.30528 8.89136 8.25 8.41602 8.25C5.10231 8.25 2.41602 10.9363 2.41602 14.25H7.21674M9.79723 8.40975C8.54887 10.1183 7.65303 12.1007 7.21674 14.25M9.91602 16.9503C9.81261 16.9713 9.70881 16.9912 9.60464 17.0101C8.69772 16.291 7.87592 15.4692 7.15681 14.5623C7.17571 14.4578 7.19569 14.3537 7.21674 14.25M4.97792 16.6408C3.87815 17.4612 3.16602 18.7724 3.16602 20.25C3.16602 20.4869 3.18432 20.7195 3.21958 20.9464C3.44656 20.9817 3.67915 21 3.91602 21C5.39359 21 6.70484 20.2879 7.52526 19.1881M16.666 9C16.666 9.82843 15.9944 10.5 15.166 10.5C14.3376 10.5 13.666 9.82843 13.666 9C13.666 8.17157 14.3376 7.5 15.166 7.5C15.9944 7.5 16.666 8.17157 16.666 9Z"
        stroke={color ?? "#1D31A5"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/**
 *
 * @param {Object} props
 * @param {String} [props.color] - The color of the icon.
 * @returns
 */

const RocketLaunchIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21 5.05577C8.1304 2.58864 11.1297 1.00014 14.5 1C14.6326 0.999994 14.7598 1.05267 14.8536 1.14644C14.9473 1.24021 15 1.36739 15 1.5C15 4.87042 13.4115 7.87 10.9443 9.79057C10.981 10.0219 11 10.2589 11 10.5C11 12.9853 8.98528 15 6.5 15C6.22386 15 6 14.7761 6 14.5V11.7456C5.99383 11.7412 5.98775 11.7366 5.98176 11.7318C5.34708 11.2286 4.772 10.6535 4.26875 10.0188C4.26385 10.0127 4.2591 10.0064 4.25452 10H1.5C1.22386 10 1 9.77614 1 9.5C1 7.01472 3.01472 5 5.5 5C5.74132 5 5.97848 5.01904 6.21 5.05577ZM10 4.5C9.17157 4.5 8.5 5.17157 8.5 6C8.5 6.82843 9.17157 7.5 10 7.5C10.8284 7.5 11.5 6.82843 11.5 6C11.5 5.17157 10.8284 4.5 10 4.5Z"
        fill={color ?? "#1D31A5"}
      />
      <path
        d="M3.50691 11.4946C3.72825 11.3294 3.77383 11.0161 3.60871 10.7948C3.44359 10.5735 3.13031 10.5279 2.90897 10.693C2.05473 11.3303 1.5 12.3504 1.5 13.4999C1.5 13.6836 1.5142 13.8644 1.54164 14.041C1.57506 14.2561 1.74383 14.4249 1.95895 14.4583C2.13558 14.4858 2.3163 14.4999 2.5 14.4999C3.64956 14.4999 4.66968 13.9452 5.30693 13.091C5.47205 12.8696 5.42647 12.5564 5.20513 12.3912C4.98379 12.2261 4.67051 12.2717 4.50539 12.493C4.04876 13.1052 3.32054 13.4999 2.5 13.4999C2.5 12.6794 2.89479 11.9512 3.50691 11.4946Z"
        fill={color ?? "#1D31A5"}
      />
    </svg>
  );
};

export default RocketLaunchIcon;
